import React, { useMemo, useEffect, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import { useNavigate } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Button } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { AxiosError } from "axios";
import { DeleteFee, FetchFeeByType, UpdateFee } from "../../apis/Fee";

const CommissionFees = () => {
  const [commissionFees, setCommissionFees] = useState([]);
  const [updateData, setUpdateData] = useState({
    commissionFeeId: "",
    propertyType: "",
    value: "",
  });
  const [deleteData, setDeleteData] = useState({
    commissionFeeId: "",
  });
  const [modal_standard, setModal_standard] = useState(false);
  const [modal_static, setModal_static] = useState(false);

  const tog_standard = () => setModal_standard((prev) => !prev);
  const tog_static = () => setModal_static((prev) => !prev);
  const navigate = useNavigate();

  const fetchCommissionFees = async () => {
    const response = await FetchFeeByType("commission");
    setCommissionFees(response.data.fees);
  };
  useEffect(() => {
    fetchCommissionFees();
  }, []);

  const handleUpdate = async () => {
    try {
      const { commissionFeeId, value } = updateData;

      const data = {
        feeId: commissionFeeId,
        valueType: "percentage",
        value,
      };

      const updatedCommissionFee = await UpdateFee(data);

      if (updatedCommissionFee) {
        toast.success("Commission Fee Updated Successfully");
        setModal_standard(false);
        fetchCommissionFees();
      } else {
        toast.error("Commission Fee Update Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const handleDelete = async () => {
    try {
      const { commissionFeeId } = deleteData;

      const response = await DeleteFee(commissionFeeId);

      if (response) {
        toast.success("Commission Fee Deleted Successfully");
        setModal_static(false);
        fetchCommissionFees();
        navigate("/commission-fees");
      } else {
        toast.error("Commission Fee Deletion Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "English Property Type Name",
        accessor: "conditions.propertyType.itemName.en",
      },
      {
        Header: "Arabic Property Type Name",
        accessor: "conditions.propertyType.itemName.ar",
      },
      {
        Header: "Commission Fee",
        accessor: "value",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value }) => new Date(value).toLocaleDateString(),
      },

      {
        Header: "Action",
        accessor: "actions",
        Cell: ({ row }) => (
          <div>
            <Button
              color="primary"
              className="btn-icon"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil"></i>
            </Button>
            <Button
              color="danger"
              className="btn-icon"
              onClick={() => handleDeleteClick(row.original)}
            >
              <i className="mdi mdi-delete"></i>
            </Button>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleEditClick = (commissionFee) => {
    setUpdateData({
      commissionFeeId: commissionFee._id,
      propertyType: commissionFee.propertyType,
      value: commissionFee.value,
    });
    tog_standard(); // Open the modal
  };

  const handleDeleteClick = (commissionFee) => {
    setDeleteData({
      commissionFeeId: commissionFee._id,
    });
    tog_static(); // Open the modal
  };
  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Commission Fee", link: "#" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0" fluid>
        <Breadcrumbs title="DATA TABLES" breadcrumbItems={breadcrumbItems} />
        <div className="p-6 flex flex-col gap-6 ">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              color="success"
              className="waves-effect waves-light me-1"
              onClick={() => navigate("/commission-fee/add")}
            >
              Add Commission Fee
            </Button>
          </div>
          <TableContainer
            columns={columns || []}
            data={commissionFees || []}
            isPagination={false}
            // isGlobalFilter={false}
            iscustomPageSize={false}
            isBordered={false}
            customPageSize={10}
          />
        </div>

        {/* START: Modal EDIT  */}
        <Modal isOpen={modal_standard} toggle={tog_standard}>
          <ModalHeader toggle={() => setModal_standard(false)}>
            Update Commission Fee
          </ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={handleUpdate}>
              <div className="mb-3">
                <AvField
                  name="value"
                  label="Commission Fee Value"
                  placeholder="Type Something"
                  type="number"
                  errorMessage="Enter commission fee value"
                  value={updateData.value}
                  validate={{
                    required: { value: true },
                    pattern: {
                      value: /^\d+(\.\d{1,2})?$/,
                      errorMessage:
                        "Only numbers with up to 2 decimal places allowed",
                    },
                    min: {
                      value: 1,
                    },
                    max: {
                      value: 100,
                    },
                  }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      value: e.target.value,
                    })
                  }
                />
              </div>
            </AvForm>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={tog_standard}
              color="light"
              className="waves-effect"
            >
              Close
            </Button>
            <Button
              type="button"
              onClick={handleUpdate}
              color="primary"
              className="waves-effect waves-light"
            >
              Save Changes
            </Button>
          </ModalFooter>
        </Modal>
        {/* END: Modal EDIT  */}

        {/* START: Modal DELETE */}

        <Modal isOpen={modal_static} toggle={tog_static} backdrop="static">
          <ModalHeader toggle={() => setModal_static(false)}>
            Delete Commission Fee
          </ModalHeader>
          <ModalBody>
            <p>Are you sure you want to delete this commission fee?</p>
            <ModalFooter>
              <Button type="button" color="light" onClick={tog_static}>
                Close
              </Button>
              <Button type="button" color="primary" onClick={handleDelete}>
                Delete
              </Button>
            </ModalFooter>
          </ModalBody>
        </Modal>
        {/* END: Modal DELETE */}
      </Container>
      </div>
    </React.Fragment>
  );
};

export default CommissionFees;
